module.exports = __webpack_public_path__ + "assets/img/ic-menu.b646208b.svg";